import { compose } from 'redux';
import { selectors } from '../../../state';
import { CUSTOM_INFORMATION_PREFIX } from '../../../constants';

export const itemCodeFromRouteParam = param =>
  `${CUSTOM_INFORMATION_PREFIX}${param}`;

export const itemKindFromState = compose(
  itemCodeFromRouteParam,
  selectors.router.currentParamsProp('code')
);

export const customInformationByRouteParam = param =>
  selectors.itemDefinition.byCode(itemCodeFromRouteParam(param));
